/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrGridColumnSortOptions } from './igr-grid-column-sort-options';
import { GridColumnSortOptions } from './GridColumnSortOptions';
import { TypeRegistrar } from "igniteui-react-core";
var IgrGridColumnSortOptionsModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridColumnSortOptionsModule() {
    }
    IgrGridColumnSortOptionsModule.register = function () {
        TypeRegistrar.registerCons('IgrGridColumnSortOptions', IgrGridColumnSortOptions);
        TypeRegistrar.registerCons('IgrGridColumnSortOptions', IgrGridColumnSortOptions);
        TypeRegistrar.register('GridColumnSortOptions', GridColumnSortOptions.$type);
    };
    return IgrGridColumnSortOptionsModule;
}());
export { IgrGridColumnSortOptionsModule };
//# sourceMappingURL=igr-grid-column-sort-options-module.js.map
